import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IndianRupee,
  BedDouble,
  MapPin,
  Ruler,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const locationPerPage = 8;

const LocationCard = ({ LocationData }) => {
  const navigate = useNavigate();
  const heading = LocationData?.taglineheading;
  const location = LocationData?.location || [];
  const totalPages = Math.ceil(location.length / locationPerPage);
  const locationtag = LocationData.locationtag;
  // Calculate the middle page
  const middlePage = Math.ceil(totalPages / 2);
  const [currentPage, setCurrentPage] = useState(middlePage);

  // Slice location based on the current page and locationPerPage
  const currentLocation = location.slice(
    (currentPage - 1) * locationPerPage,
    currentPage * locationPerPage
  );

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const redirect = (url) => {
    if (url) navigate(url);
  };

  return (
    <div className="w-full flex justify-center">
      <div className="w-full flex flex-col  lg:w-4/5 xl:w-5/6 px-2 md:px-0">
        <div className=" leading-3">
          <h3 className=" section-title__title font-medium   flex justify-center items-center text-center text-[#374151]">
            {heading}
          </h3>
        </div>
        <div className=" flex flex-col items-center justify-center ">
          {/* Responsive grid container for cards */}
          <div className=" flex flex-wrap  gap-8 md:gap-20 justify-center itec w-full mt-10">
            {currentLocation.map((location, index) => (
              <a
                href={location.link}
                key={index}
                
                className="relative group md:max-w-[250px] h-[350px] 
                                bg-[#fff5e4] overflow-hidden rounded-xl"
                onClick={() => redirect(location.url)}
              >
                <div className="w-full md:px-10 px-3 absolute flex flex-col md:mt-10 mt-3 ">
                  <h2 className="flex items-center text-[#374151]  text-[18px] font-medium">
                    {location.title}
                  </h2>
                  <h2 className="text-[#65666a] text-[12px] font-medium">
                    {location.propertcount} <span>+ Properties</span>
                  </h2>
                </div>

                <img
                  src={location.image || "/placeholder.png"}
                  alt={location.name || "No Name"}
                  className="w-full  object-cover transition-all duration-300"
                />
              </a>
            ))}
          </div>

          {/* Pagination Buttons */}
          <div className="mt-8 flex items-center gap-4">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className={`px-2 py-1 rounded-md ${
                currentPage === 1
                  ? "bg-gray-400 opacity-50 cursor-not-allowed"
                  : "bg-gray-700 hover:bg-gray-700"
              }`}
            >
              <ChevronLeft />
            </button>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className={`px-2 py-1 rounded-md ${
                currentPage === totalPages
                  ? "bg-gray-400 opacity-50 cursor-not-allowed"
                  : "bg-gray-700 hover:bg-gray-700"
              }`}
            >
              <ChevronRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationCard;